import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../APIConfig";
import AuthAPI from "../AuthAPI";

export const _AwayTrips = {
    reasonsList: id_dipendente => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/away-trips/reasons/list"),
            {
                id_dipendente: id_dipendente,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    routesList: id_dipendente => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/away-trips/routes/list"),
            {
                id_dipendente: id_dipendente,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    vehiclesList: id_dipendente => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/away-trips/vehicles/list"),
            {
                id_dipendente: id_dipendente,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    save: payload => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url("/modulo-hr/away-trips/save"),
            {
                ...(payload || {}),
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    pagination: (id_dipendente, page = 1, filters = null, sortFields = null) => {
        const params = {
            page: page,
            token: AuthAPI.getUserAccessToken()
        };
        if (Array.isArray(id_dipendente)) {
            params["id_dipendente[]"] = id_dipendente;
        } else {
            params.id_dipendente = id_dipendente;
        }
        if (filters) {
            params.filters = filters;
        }
        if (sortFields) {
            params.sortFields = typeof sortFields === "string" ? sortFields : JSON.stringify(sortFields);
        }
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/away-trips/pagination"),
            params,
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    details: trip_id => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/away-trips/details"),
            {
                trip_id: trip_id,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    delete: trip_id => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url("/modulo-hr/away-trips/delete"),
            {
                trip_id: trip_id,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    requestReview: trip_id => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url("/modulo-hr/away-trips/request-review"),
            {
                trip_id: trip_id,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    logsPagination: (trip_id, page = 1) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/away-trips/logs/pagination"),
            {
                trip_id: trip_id,
                page: page,
                token: AuthAPI.getUserAccessToken()
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    }
};
